import { FileImageOutlined, UploadOutlined } from '@ant-design/icons'
import { Typography } from '@sureco/design-system'
import type { UploadProps } from 'antd'
import { Button, Image, message, Upload } from 'antd'
import { RcFile } from 'antd/es/upload'
import React from 'react'
import styles from './UploadButton.module.scss'

type UploadButtonProps = UploadProps & {
  logo?: string
  onImageUploaded: (base64: string) => void
}

const UploadButton: React.FC<UploadButtonProps> = ({
  onImageUploaded,
  logo,
  ...rest
}) => {
  const getBase64 = (file: RcFile): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = (error) => reject(error)
    })
  }

  const props: UploadProps = {
    name: 'file',
    beforeUpload: async (file) => {
      if (!file.type.startsWith('image/')) {
        message.error('You can only upload image files!')
        return Upload.LIST_IGNORE
      }

      try {
        const base64 = await getBase64(file)
        onImageUploaded(base64)
        message.success('Image processed successfully')
      } catch (err) {
        message.error('Error processing image')
      }

      return false
    },
    maxCount: 1,
    accept: 'image/*',
  }

  return (
    <div className={styles.uploadButton}>
      <div className={styles.uploadButtonImage}>
        {logo ? (
          <Image
            width={200}
            height={200}
            src={logo}
            style={{ border: '1px solid #AAB5BD' }}
          />
        ) : (
          <div
            style={{
              width: 200,
              height: 200,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #AAB5BD',
              borderRadius: '0.5rem',
              gap: '0.5rem',
            }}
          >
            <FileImageOutlined style={{ fontSize: '2rem' }} />
            <Typography size={16}>No Image</Typography>
          </div>
        )}
      </div>
      <div>
        <Upload {...rest} {...props}>
          <Button icon={<UploadOutlined />}>Click to Upload Logo</Button>
        </Upload>
        <Typography size={14}>
          Size should be less than 600KB, and supported formats are JPEG, PNG,
          and JPG.
        </Typography>
      </div>
    </div>
  )
}

export default UploadButton
